import styles from "./IconButton.module.css";
import { Button, ButtonProps } from "./Button";
import { clsx } from "clsx";

type IconButtonProps = ButtonProps;

export function IconButton({ children, className, ...props }: IconButtonProps) {
  return (
    <Button className={clsx(styles.iconButtonRoot, className)} {...props}>
      {children}
    </Button>
  );
}
